import React, { useCallback, useEffect, useState } from "react";
import { getProcurement } from "../api/procurement";
import AccordionItem from "../components/AccordionItem";
import Container from "../components/Container";
import MainCard from "../components/MainCard";
import PageContainer from "../components/PageContainer";
import DocLists from "../sections/standards/DocLists";
import { toThaiDate } from "../utils/globalFunctions";

const mockup = [
  {
    id: 1,
    title: "ประกาศจัดซื้อจัดจ้าง",
    children: [
      {
        title: "แผนจัดซื้อจัดจ้าง 1",
        children: [
          {
            pdflink: "https://www.google.com",
            pdftitle: "แผนจัดซื้อจัดจ้าง 1",
          },
          {
            pdflink: "https://www.google.com",
            pdftitle: "แผนจัดซื้อจัดจ้าง 2",
          },
          {
            pdflink: "https://www.google.com",
            pdftitle: "แผนจัดซื้อจัดจ้าง 3",
          },
        ],
      },
    ],
  },
  {
    id: 2,
    title: "แผนจัดซื้อจัดจ้าง 2",
    children: [
      {
        title: "แผนจัดซื้อจัดจ้าง 1",
        children: [
          {
            pdflink: "https://www.google.com",
            pdftitle: "แผนจัดซื้อจัดจ้าง 1",
          },
          {
            pdflink: "https://www.google.com",
            pdftitle: "แผนจัดซื้อจัดจ้าง 2",
          },
          {
            pdflink: "https://www.google.com",
            pdftitle: "แผนจัดซื้อจัดจ้าง 3",
          },
        ],
      },
    ],
  },
];

const Procurement = () => {
  const [activeTab, setActiveTab] = useState("0");
  const [docs, setDocs] = useState({
    title: "",
    children: [],
  });

  const [pageData, setPageData] = useState([]);

  const getData = useCallback(
    () =>
      getProcurement()
        .then((res) => {
          const data = res.map((val) => {
            return {
              type: val.anounceType,
              title: val.anounceTypeName,
              children: val.item.map((item) => {
                return {
                  pdflink: item.link,
                  pdftitle: item.title,
                  description: `วันที่ประกาศ : ${toThaiDate(item.pubDate)}`,
                };
              }),
            };
          });

          setDocs(data[0]);

          setPageData(data);
        })
        .catch((err) => console.log(err)),
    [setPageData]
  );

  useEffect(() => {
    getData();
  }, [getData]);

  const displaySideLst = (
    <div>
      {mockup.map((item, index) => {
        return (
          <AccordionItem title={item.title}>
            <ul className="space-y-2">
              {item.children.map((child, cIndex) => {
                return (
                  <li
                    key={`${index}-${cIndex}`}
                    className={`p-3 rounded-lg cursor-pointer ${
                      activeTab === `${index}-${cIndex}`
                        ? "bg-[#3F288D] text-white"
                        : "text-gray-700 hover:bg-gray-200"
                    }`}
                    onClick={() => {
                      setActiveTab(`${index}-${cIndex}`);

                      setDocs({
                        title: child.title,
                        children: child.children,
                      });
                    }}
                  >
                    {child.title}
                  </li>
                );
              })}
            </ul>
          </AccordionItem>
        );
      })}
    </div>
  );

  return (
    <PageContainer title="ประกาศจัดซื้อจัดจ้าง แผนจัดซื้อจัดจ้าง">
      <Container isAlignTop>
        <div className="flex gap-4">
          <div className="w-1/4">
            <MainCard>
              <ul className="space-y-2">
                {pageData.map((child, cIndex) => {
                  return (
                    <li
                      key={`${cIndex}`}
                      className={`p-3 rounded-lg cursor-pointer ${
                        activeTab === `${cIndex}`
                          ? "bg-[#3F288D] text-white"
                          : "text-gray-700 hover:bg-gray-200"
                      }`}
                      onClick={() => {
                        setActiveTab(`${cIndex}`);

                        setDocs({
                          title: child.title,
                          children: child.children,
                        });
                      }}
                    >
                      {child.title}
                    </li>
                  );
                })}
              </ul>
            </MainCard>
          </div>
          <div className="w-3/4">
            <MainCard>
              <div className="bg-white p-4 border border-gray-100 rounded-lg shadow-md">
                <h3>{docs.title}</h3>
              </div>
              {!!docs.children.length && (
                <DocLists
                  docs={docs.children}
                  keyLabel="pdftitle"
                  onDocClick={(doc) => window.open(doc.pdflink, "_blank")}
                />
              )}
            </MainCard>
          </div>
        </div>
      </Container>
    </PageContainer>
  );
};

export default Procurement;
